import { put, select, takeLatest } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddMedicationAdministeredData } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'

export function* setDoseUnit() {
  const addMedicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { doseUnit, doseUnitPNNV, medicationAdministered, addMedicationAdministeredData } =
    addMedicationAdministeredState
  const selectedMedication = addMedicationAdministeredData.filter(
    (medication) => medication.key === medicationAdministered?.key
  )
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].doseUnit = doseUnit
    selectedMedication[0].doseUnitPNNV = !doseUnit ? doseUnitPNNV : null
    yield put(setAddMedicationAdministeredData(addMedicationAdministeredData))
  }
}
export function* setDoseUnitSaga() {
  yield takeLatest(
    [AddMedicationAdministeredConstants.SET_DOSE_UNIT, AddMedicationAdministeredConstants.SET_DOSE_UNIT_PNNV],
    setDoseUnit
  )
}
